export default __webpack_public_path__ + "static/media/business-288e.b0b992d5.jpg";